import { render, staticRenderFns } from "./approve_ratio.vue?vue&type=template&id=5e9f0c24"
import script from "./approve_ratio.vue?vue&type=script&lang=js"
export * from "./approve_ratio.vue?vue&type=script&lang=js"
import style0 from "./approve_ratio.vue?vue&type=style&index=0&id=5e9f0c24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports